import { render, staticRenderFns } from "./create-user.vue?vue&type=template&id=64fb13c4&scoped=true&"
import script from "./create-user.vue?vue&type=script&lang=tsx&"
export * from "./create-user.vue?vue&type=script&lang=tsx&"
import style0 from "./create-user.vue?vue&type=style&index=0&id=64fb13c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb13c4",
  null
  
)

export default component.exports